module.exports = __webpack_public_path__ + "static/square-914389a88cfffa2a75d07d83b9cb3bb9.png";